import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'CheckmarkIcon',
  'checkmark',
  'M856.146 689.698c19.005-19.069 19.005-49.987 0-69.057l-412.975-414.341c-19.006-19.067-49.822-19.067-68.829 0l-206.487 207.171c-19.007 19.072-19.007 49.988 0 69.058s49.822 19.069 68.829 0l172.073-172.64 378.561 379.81c19.005 19.069 49.823 19.069 68.828 0z',
)
